import { inject } from '@angular/core';
import { PERMISSIONS } from '@shared/constants';
import { LearnerApiService } from '@shared/services/learner-api.service';
import { PLACEHOLDER_FUNCTIONS, TableConfig } from '../generic-p-table.interfaces';

export const learnerTableConfig = (): TableConfig => {
  const learnerApiService = inject(LearnerApiService);

  return {
    title: 'Danh sách học viên',
    entityName: 'học viên',
    service: learnerApiService,
    method: 'getLearners',
    columns: [
      { field: 'code', header: 'Mã', width: 'min-w-[100px]', sortable: true, type: 'text' },
      { field: 'profile.fullname', header: 'Họ tên', width: 'min-w-[200px]', sortable: true, type: 'text' },
      { field: 'emails', header: 'Email', width: 'min-w-[220px]', sortable: false, type: 'custom' },
      { field: 'phones', header: 'Số điện thoại', width: 'min-w-[180px]', sortable: false, type: 'custom' },
      { field: 'relatives', header: 'Người thân', width: 'min-w-[280px]', sortable: false, type: 'custom' }
    ],
    features: {
      virtualScroll: true,
      toolbar: true
    },
    actions: [
      {
        location: 'row',
        useDefaultStyle: 'edit',
        permission: PERMISSIONS.LEARNER_EDIT.code,
        onClick: PLACEHOLDER_FUNCTIONS.EDIT
      },
      {
        location: 'toolbar',
        useDefaultStyle: 'add',
        onClick: PLACEHOLDER_FUNCTIONS.OPEN_NEW
      },
    ]
  };
};

